import { Box } from "@chakra-ui/react";
import { FC } from "react";

interface EmbedPlayerProps {
  /** The full iframe src URL, already built by the caller. */
  embedUrl: string;
  title: string;
  className?: string;
}

/**
 * Generic responsive iframe player.
 * Used for Vimeo, Loom, and any other embed-based video provider.
 * The caller is responsible for building the correct `embedUrl`.
 */
const EmbedPlayer: FC<EmbedPlayerProps> = ({ embedUrl, title, className }) => (
  <Box
    as="iframe"
    className={className}
    src={embedUrl}
    allow="autoplay; fullscreen; picture-in-picture"
    allowFullScreen
    frameBorder={0}
    title={title}
  />
);

export default EmbedPlayer;
